import { render, staticRenderFns } from "./RegisterTable.vue?vue&type=template&id=e74a4a00&"
import script from "./RegisterTable.vue?vue&type=script&lang=js&"
export * from "./RegisterTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports